import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-grid__cell gfu-1of3 _mt-1"
}
const _hoisted_2 = ["data-qa"]
const _hoisted_3 = {
  class: "gfu-grid__cell gfu-6of12",
  "data-qa": "minValue"
}
const _hoisted_4 = {
  class: "gfu-grid__cell gfu-6of12",
  "data-qa": "maxValue"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field_label = _resolveComponent("field-label")
  const _component_number_field = _resolveComponent("number-field")

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_field_label, {
          class: "gfu-field__label--gray _mt-1",
          text: _ctx.displayName
        }, null, 8 /* PROPS */, ["text"]),
        _createElementVNode("div", {
          class: "gfu-grid gfu-grid--gutter-columns",
          "data-qa": `filtersbox-field:${_ctx.displayName}`
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_number_field, {
              modelValue: _ctx.modelValue[$props.minValueFieldName],
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.modelValue[$props.minValueFieldName]) = $event)),
              inline: true,
              integer: $props.integer,
              "show-label": false,
              small: true,
              onKeyup: _withKeys(_ctx.applyFilter, ["enter"])
            }, null, 8 /* PROPS */, ["modelValue", "integer", "onKeyup"])
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "gfu-divider gfu-divider--small" }, "to", -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_number_field, {
              modelValue: _ctx.modelValue[$props.maxValueFieldName],
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.modelValue[$props.maxValueFieldName]) = $event)),
              inline: true,
              integer: $props.integer,
              "show-label": false,
              small: true,
              onKeyup: _withKeys(_ctx.applyFilter, ["enter"])
            }, null, 8 /* PROPS */, ["modelValue", "integer", "onKeyup"])
          ])
        ], 8 /* PROPS */, _hoisted_2)
      ]))
    : _createCommentVNode("v-if", true)
}